import { Component, OnInit, inject, ChangeDetectionStrategy } from '@angular/core';
import { IReportSearch } from '../interfaces/ireport-search';
import { ReportService } from '@core/services/report.service';
import { LanguageService } from '@core/services/language.service';
import { take } from 'rxjs';
import { IRequiredReportFields } from '../interfaces/irequired-report-fields';
import { Permission } from '@core/enums/permissions';
import { PermissionService } from '@core/services/permission.service';
import { LookupService } from '@core/services/lookup.service';
import { ActivatedRoute } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
@Component({
    selector: 'drdp-group',
    templateUrl: './group.component.html',
    styleUrls: ['./group.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GroupComponent implements OnInit {

  private reportService = inject(ReportService);
  private languageService = inject(LanguageService);
  private route = inject(ActivatedRoute);
  is2025: boolean = false;
  title: string = '';
  reportData:  string | undefined;
  loading: boolean = false;
  hasAccessToAssignedChildren = this.permissionService.checkPermission(
    Permission.AccessToAssignedChildrenReporting
  );
  currentSchoolYear: number | undefined;
  requiredFields: IRequiredReportFields = {
    state: true,
    agency: !this.hasAccessToAssignedChildren,
    globalRatingPeriod: true,
    site: !this.hasAccessToAssignedChildren,
    classroom: !this.hasAccessToAssignedChildren,
    ageGroup: true,
    requireMultipleRatingPeriods: false
  }
  constructor(private permissionService: PermissionService, private lookupService: LookupService, private translocoService: TranslocoService) { }

  ngOnInit(): void {
    this.is2025 = this.route.snapshot.data['is2025'] ?? false;
    this.title = this.translocoService.translate('reports.group.title', { year: this.is2025 ? '2025' : '2015' });
    if (this.is2025) {
      this.requiredFields.ageGroup = false;
    }
  }
  showReport(searchValues: IReportSearch) {
    this.loading = true;
    if (!searchValues.locale) {
      searchValues.locale = this.languageService.activeId();
    }

    const service = (payload: IReportSearch) =>
      this.is2025
        ? this.reportService.generateGroupReport2025(payload)
        : this.reportService.generateGroupReport(payload);

    service(searchValues)
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          this.reportData = res;
        },
        complete: () => {
          this.loading = false;
        }
      });

      
  }

  downloadReport(searchValues: IReportSearch) {
    this.loading = true;

     const service = (payload: IReportSearch) =>
      this.is2025
        ? this.reportService.generateGroupReport2025Pdf(payload)
        : this.reportService.generateGroupReportPdf(payload);

   service(searchValues)
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          const file = new Blob([res], { type: 'application/pdf' });
          const fileUrl = URL.createObjectURL(file);
          const link = document.createElement('a');
          link.href = fileUrl;
          let fileName = `group_report`;
          link.download = `${fileName.replace(/ /g, '_')}.pdf`;
          link.click();
        },
        complete: () => {
          this.loading = false;
        }
      });
  }

  handleClear(): void {
    this.reportData = undefined;
  }
}
